"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.view = void 0;
var csod = require("player-core");
var mapping_1 = require("../../mapping");
var application_1 = require("../../models/application");
var ApplicationActions_1 = require("../../actions/ApplicationActions");
var constants = require("../../shared/code/Constants");
var player_globalization_1 = require("player-globalization");
var debounce = require("lodash/debounce");
var delayedCommit = debounce(function () { csod.engine.commit(); }, 100);
function view() {
    var _this = this;
    var resumeActions = new ApplicationActions_1.ApplicationWorkflowResumeActions(this);
    var getShowResumeUpload = function (props) { return props.actionItem.resumeFileUploadToken.deleteUrl === ''; };
    return {
        state: {
            actionItem: this.props.actionItem,
            isContactDetailsVisible: this.props.actionItem.parsingType != 0,
            hasAdditionalAttachments: this.props.actionItem.additionalAttachments.length > 0,
            isResumeFieldsVisible: this.props.actionItem.parsingType === 2,
            defaultDropdownOptionText: this.props.defaultDropdownOptionText,
            showResumeUpload: getShowResumeUpload(this.props),
            allowedAttributes: {
                a: ['href', 'name', 'target', 'class'],
                img: ['src', 'alt'],
                span: ['style']
            },
            fileUploadIsEnabled: !csod.viewModel.isPreview,
            constants: constants
        },
        initialize: function () {
            return new Promise(function (resolve) {
                if (!_this.view.state.actionItem.resumeFileUploadToken.value) {
                    _this.view.state.actionItem.resumeFileUploadToken.value = ApplicationActions_1.createUUID();
                }
                _this.view.state.actionItem.additionalAttachments.forEach(function (attachment) {
                    attachment.fileUploads.forEach(function (fileUpload) {
                        if (!fileUpload.token.value) {
                            fileUpload.token.value = ApplicationActions_1.createUUID();
                        }
                    });
                });
                _this.view.helpers.transformData();
                resumeActions.initializeResumeViewer();
                _this.props.onActionLoaded();
                resolve();
            });
        },
        mounted: function () {
            _this.view.helpers.returnResultsToPage();
        },
        receivedProps: function (nextProps) {
            _this.view.state.actionItem = nextProps.actionItem;
            _this.view.helpers.transformData();
            _this.view.state.showResumeUpload = getShowResumeUpload(nextProps);
            _this.view.helpers.returnResultsToPage();
            return new Promise(function (resolve) {
                resolve();
            });
        },
        unmount: function () { },
        events: {
            onResumeUploadSuccess: function (data) {
                _this.view.state.actionItem.resumeFileUploadToken.errorMessage = '';
                if (data.files[0].errors !== null && data.files[0].errors.length > 0) {
                    _this.view.state.actionItem.resumeFileUploadToken.errorMessage = data.files[0].errors[0].Value;
                    _this.view.helpers.returnResultsToPage();
                }
                else {
                    _this.props.onLoadingChanged(true);
                    _this.props.onChangeSpinnerText(true, _this.props.parsingResumeText);
                    var baseUploaderUrl = csod.context.applicationBase + "uploader/";
                    _this.view.state.actionItem.resumeFileUploadToken.title = data.files[0].name;
                    _this.view.state.actionItem.resumeFileUploadToken.fileSize = Math.floor(data.files[0].length / 1000) + ' KB';
                    _this.view.state.actionItem.resumeFileUploadToken.fileUrl = '';
                    _this.view.state.actionItem.resumeFileUploadToken.deleteUrl = baseUploaderUrl + data.files[0].delete_url;
                    _this.view.state.actionItem.resumeFileUploadToken.fileIcon = ApplicationActions_1.getFileIconBasedFromFileType(data.files[0].name);
                    _this.view.state.actionItem.resumeFileUploadToken.brandIcon = '';
                    _this.view.state.actionItem.resumeSourceType = 1;
                    _this.view.state.showResumeUpload = false;
                    _this.view.helpers
                        .parseResume()
                        .then(function () {
                        _this.view.helpers.returnResultsToPage();
                        _this.props.onLoadingChanged(false);
                        _this.props.onChangeSpinnerText(false);
                        csod.engine.commit();
                    })
                        .catch(function () {
                        _this.props.onLoadingChanged(false);
                        _this.props.onChangeSpinnerText(false);
                    });
                }
            },
            onResumeUploadError: function (error, message) {
                if (error != null) {
                    console.log('onFileUploadError:', error);
                    message = _this.props.fileUploadErrorMessage;
                }
                _this.view.state.actionItem.resumeFileUploadToken.errorMessage = message;
            },
            onResumeDelete: function (id) {
                if (_this.view.state.actionItem.resumeFileUploadToken.deleteUrl) {
                    _this.props.onLoadingChanged(true);
                    csod.service
                        .post(_this.view.state.actionItem.resumeFileUploadToken.deleteUrl)
                        .catch(function (error) {
                        _this.props.onLoadingChanged(false);
                    })
                        .then(function (data) {
                        _this.view.state.actionItem.resumeFileUploadToken.value = ApplicationActions_1.createUUID();
                        _this.view.helpers.displayResumeUpload();
                        _this.view.helpers.returnResultsToPage();
                        csod.engine.commit();
                        _this.props.onLoadingChanged(false);
                    });
                }
                else {
                    _this.view.helpers.displayResumeUpload();
                    _this.view.helpers.returnResultsToPage();
                }
            },
            onResumeDataChanged: function (value, id) {
                resumeActions.resumeDataChanged(value, id);
                return false;
            },
            onContactDetailsChanged: function (value, id) {
                resumeActions.contactDetailsChanged(value, id);
                return false;
            },
            onContactDetailsUpdated: function () {
            },
            onContactDetailsCountryChanged: function (value) {
                resumeActions.contactDetailsCountryChanged(value);
                delayedCommit();
                return false;
            },
            onAddEntry: function (sectionId) {
                resumeActions.addEntry(sectionId);
                return false;
            },
            onEntryDeleted: function (sectionId, entry, entryIndex) {
                resumeActions.deleteEntry(sectionId, entry, entryIndex);
                return false;
            },
            onChangeDate: function (date, value, isValid, id) {
                resumeActions.changeDate(date, value, isValid, id);
                return false;
            },
            onChangeDaterange: function (date, value, isValid, id) {
                resumeActions.changeDaterange(date, value, isValid, id);
                return false;
            },
            onResumeDataChangeNoId: function (value, field) {
                resumeActions.resumeDataChangeNoId(value, field);
                return false;
            },
            onCoverLetterDataChanged: function () {
                resumeActions.coverLetterDataChanged();
                return false;
            },
            onAdditionalAttachmentUploadSuccess: function (data, fileUploadId) {
                resumeActions.onAdditionalAttachmentUploadSuccess(data, fileUploadId);
            },
            onAdditionalAttachmentUploadError: function (error, message, fileUploadId) {
                resumeActions.onAdditionalAttachmentUploadError(error, message, fileUploadId);
            },
            onAdditionalAttachmentDelete: function (fileViewerId) {
                resumeActions.onAdditionalAttachmentDelete(fileViewerId);
            },
            onAdditionalAttachmentCreate: function (e, attachment) {
                resumeActions.onAdditionalAttachmentCreate(attachment);
            }
        },
        helpers: {
            returnResultsToPage: function () {
                var resultData = new application_1.ResumeResultData();
                resultData.actionId = _this.view.state.actionItem.id;
                resultData.type = application_1.ActionType.resume;
                resultData.contactDetails = new application_1.ContactDetailsResultData();
                resultData.contactDetails.addressLine1 = _this.view.state.actionItem.contactDetails.addressLine1.value;
                resultData.contactDetails.addressLine2 = _this.view.state.actionItem.contactDetails.addressLine2.value;
                resultData.contactDetails.city = _this.view.state.actionItem.contactDetails.city.value;
                resultData.contactDetails.state = _this.view.state.actionItem.contactDetails.state.value;
                resultData.contactDetails.countryCode = _this.view.state.actionItem.contactDetails.country.value;
                resultData.contactDetails.zipCode = _this.view.state.actionItem.contactDetails.zipCode.value;
                resultData.contactDetails.phoneNumber = _this.view.state.actionItem.contactDetails.phone.value.phoneNumber;
                resultData.contactDetails.phoneNumberValid = _this.view.state.actionItem.contactDetails.phone.value.phoneNumberValid;
                resultData.contactDetails.phoneNumberCountryCode = _this.view.state.actionItem.contactDetails.phone.value.countryCode;
                resultData.contactDetails.isUserOptedInTextMessages = _this.view.state.actionItem.contactDetails.isUserOptedInTextMessages.value.toString() === "true";
                resultData.resumeSourceType = _this.view.state.actionItem.resumeSourceType;
                if (resultData.resumeSourceType === 7) {
                    resultData.socialNetworkProfileData = csod.viewModel.applyWithLinkedInData.profileData;
                }
                resultData.resumeFileUploadToken = _this.view.state.actionItem.resumeFileUploadToken.value;
                resultData.resumeFileUploadInfo = new application_1.FileUploadField();
                resultData.resumeFileUploadInfo.title = _this.view.state.actionItem.resumeFileUploadToken.title;
                resultData.resumeFileUploadInfo.fileSize = _this.view.state.actionItem.resumeFileUploadToken.fileSize;
                resultData.resumeFileUploadInfo.fileUrl = _this.view.state.actionItem.resumeFileUploadToken.fileUrl;
                resultData.resumeFileUploadInfo.deleteUrl = _this.view.state.actionItem.resumeFileUploadToken.deleteUrl;
                resultData.resumeFileUploadInfo.fileIcon = _this.view.state.actionItem.resumeFileUploadToken.fileIcon;
                resultData.resumeFileUploadInfo.fileIconBackgroundColor = _this.view.state.actionItem.resumeFileUploadToken.fileIconBackgroundColor;
                resultData.coverLetterFileUploadToken = _this.view.state.actionItem.coverLetter.fileUploadToken.value;
                resultData.coverLetterFileUploadInfo = new application_1.FileUploadField();
                resultData.coverLetterFileUploadInfo.title = _this.view.state.actionItem.coverLetter.fileUploadToken.title;
                resultData.coverLetterFileUploadInfo.fileSize = _this.view.state.actionItem.coverLetter.fileUploadToken.fileSize;
                resultData.coverLetterFileUploadInfo.fileUrl = _this.view.state.actionItem.coverLetter.fileUploadToken.fileUrl;
                resultData.coverLetterFileUploadInfo.deleteUrl = _this.view.state.actionItem.coverLetter.fileUploadToken.deleteUrl;
                resultData.coverLetterFileUploadInfo.fileIcon = _this.view.state.actionItem.coverLetter.fileUploadToken.fileIcon;
                resultData.coverLetterFileUploadInfo.fileIconBackgroundColor = _this.view.state.actionItem.coverLetter.fileUploadToken.fileIconBackgroundColor;
                resultData.coverLetterText = _this.view.state.actionItem.coverLetter.coverLetterText;
                resultData.additionalAttachmentsRequest = new Array();
                _this.view.state.actionItem.additionalAttachments.forEach(function (attachment) {
                    attachment.fileUploads.forEach(function (fileUpload) {
                        var _a = fileUpload.id.split('_'), section = _a[0], type = _a[1], index = _a[2], attachmentId = _a[3];
                        var attachmentRequest = new application_1.AttachmentResultData();
                        attachmentRequest.attachmentFileToken = fileUpload.token.value;
                        attachmentRequest.attachmentId = attachmentId;
                        attachmentRequest.fileUploadInfo = Object.assign({}, fileUpload.token);
                        resultData.additionalAttachmentsRequest.push(attachmentRequest);
                    });
                });
                resultData.socialResume = new application_1.SocialResumeInfo();
                resultData.socialResume.socialProviderId = _this.props.socialNetworkProviderId;
                resultData.socialResume.socialId = _this.props.socialId;
                resultData.resumeStructure = new application_1.ResumeStructureResultData();
                resultData.resumeStructure.sections = [];
                if (_this.view.state.actionItem.resumeStructure.sections) {
                    _this.view.state.actionItem.resumeStructure.sections.map(function (section) {
                        var newSection = new application_1.SectionResultData();
                        newSection.sectionId = section.sectionId;
                        newSection.entries = [];
                        section.entries.map(function (entry) {
                            var newEntry = new application_1.ResumeEntry();
                            newEntry.entryId = entry.entryId;
                            newEntry.values = [];
                            entry.values.map(function (entryValue) {
                                var newEntryValue = new application_1.ResumeEntryValue();
                                newEntryValue.fieldId = entryValue.fieldId;
                                newEntryValue.value1 = entryValue.value1;
                                newEntryValue.value2 = entryValue.value2;
                                if (entryValue.fieldData && entryValue.fieldData.fieldTypeString === 'dateRangeField') {
                                    newEntryValue.value1 = entryValue.value1 ? player_globalization_1.Culture.toUniversalDate(entryValue.value1) : '';
                                    newEntryValue.value2 = entryValue.value2 ? player_globalization_1.Culture.toUniversalDate(entryValue.value2) : '';
                                }
                                else if (entryValue.fieldData && entryValue.fieldData.fieldTypeString === 'dateField') {
                                    newEntryValue.value1 = entryValue.value1 ? player_globalization_1.Culture.toUniversalDate(entryValue.value1) : '';
                                }
                                newEntry.values.push(newEntryValue);
                            });
                            newSection.entries.push(newEntry);
                        });
                        resultData.resumeStructure.sections.push(newSection);
                    });
                }
                _this.props.onDataChanged(resultData);
            },
            parseResume: function () {
                return mapping_1.parseResume(_this.view.state.actionItem.resumeFileUploadToken.value, _this.view.state.actionItem.parsingType).then(function (data) {
                    if (data.contactDetails != null || data.resumeStructure != null) {
                        var contactDetails = _this.view.state.actionItem.contactDetails;
                        contactDetails.addressLine1.value = data.contactDetails.addressLine1.value;
                        contactDetails.addressLine2.value = data.contactDetails.addressLine2.value;
                        contactDetails.city.value = data.contactDetails.city.value;
                        contactDetails.state.value = data.contactDetails.state.value;
                        contactDetails.zipCode.value = data.contactDetails.zipCode.value;
                        contactDetails.country.value = data.contactDetails.country.value;
                        contactDetails.phone.value = data.contactDetails.phone.value;
                        if (_this.view.state.actionItem.resumeStructure.sections) {
                            _this.view.state.actionItem.resumeStructure.sections.map(function (section, sIndex) {
                                if (section.entries != undefined) {
                                    section.entries.length = 0;
                                }
                            });
                        }
                        _this.view.state.actionItem.resumeStructure = Object.assign({}, data.resumeStructure);
                        _this.view.helpers.transformData();
                    }
                });
            },
            transformData: function () {
                if (_this.view.state.actionItem.resumeStructure.sections) {
                    _this.view.state.actionItem.resumeStructure.sections.map(function (section, sIndex) {
                        if (section.entries != undefined) {
                            section.entries.map(function (entry, eIndex) {
                                return entry.values.map(function (value, vIndex) {
                                    return (value.fieldData = _this.view.helpers.populateFieldData(value, section.fields, sIndex, eIndex, vIndex));
                                });
                            });
                        }
                        else {
                            section.entries = [];
                        }
                    });
                }
            },
            getFieldData: function (fields, fieldId) {
                var fieldData = fields.filter(function (f) { return f.fieldId === fieldId; })[0];
                return Object.assign({}, fieldData);
            },
            getFieldWidth: function (fieldType) {
                var width = '12';
                if (fieldType === 1 || fieldType === 4 || fieldType == 3 || fieldType == 13 || fieldType == 18) {
                    width = '6';
                }
                else if (fieldType === 6) {
                    width = '3';
                }
                return width;
            },
            transformFieldType: function (fieldType) {
                var fieldTypes = {
                    1: 'shortTextBox',
                    2: 'scrollingTextBox',
                    3: 'dropdown',
                    4: 'numericField',
                    6: 'dateField',
                    7: 'checkbox',
                    13: 'attributeList',
                    18: 'dateRangeField'
                };
                return fieldTypes[fieldType];
            },
            generateIdTag: function (sIndex, eIndex, vIndex) {
                return "$resume-field_" + sIndex + "_" + eIndex + "_" + vIndex;
            },
            getDropdownDefault: function (options) {
                var defaultValue = options.filter(function (o) { return o.isDefault; });
                if (defaultValue.length) {
                    return defaultValue[0].key;
                }
                else {
                    return '';
                }
            },
            getDisplayFullDateSetting: function (settings) {
                var displayFullDate = true;
                settings.forEach(function (s) {
                    if (s.key === 'DisplayFullDate') {
                        displayFullDate = s.value === 'True' ? true : false;
                    }
                });
                return displayFullDate;
            },
            transformDropdownOptions: function (options) {
                var newOptions = options.map(function (o) {
                    return {
                        label: o.value,
                        value: o.key
                    };
                });
                newOptions.splice(0, 0, {
                    label: _this.view.state.defaultDropdownOptionText,
                    value: ''
                });
                return newOptions;
            },
            populateFieldData: function (fieldValue, fields, sectionIndex, entryIndex, valueIndex) {
                var fieldData = _this.view.helpers.getFieldData(fields, fieldValue.fieldId);
                fieldData['width'] = _this.view.helpers.getFieldWidth(fieldData.fieldType);
                fieldData['fieldTypeString'] = _this.view.helpers.transformFieldType(fieldData.fieldType);
                fieldData['idTag'] = _this.view.helpers.generateIdTag(sectionIndex, entryIndex, valueIndex);
                if (fieldData.fieldTypeString === 'dropdown' || fieldData.fieldTypeString === 'attributeList') {
                    fieldData['items'] = _this.view.helpers.transformDropdownOptions(fieldData.options);
                }
                else if (fieldData.fieldTypeString === 'checkbox') {
                    fieldValue.value1 = fieldValue.value1 == true || fieldValue.value1 === 'True' || fieldValue.value1 === 'true';
                }
                else if (fieldData.fieldTypeString === 'dateField' || fieldData.fieldTypeString === 'dateRangeField') {
                    fieldData['displayFullDate'] = _this.view.helpers.getDisplayFullDateSetting(fieldData.settings);
                    if (!(fieldValue.value1 instanceof Date) && fieldValue.value1 !== '' && fieldValue.value1 !== null) {
                        fieldValue.value1 = player_globalization_1.Culture.parseDate(fieldValue.value1);
                    }
                    if (!(fieldValue.value2 instanceof Date) && fieldValue.value2 !== '' && fieldValue.value2 !== null) {
                        fieldValue.value2 = player_globalization_1.Culture.parseDate(fieldValue.value2);
                    }
                }
                return fieldData;
            },
            displayResumeUpload: function () {
                _this.view.state.actionItem.resumeSourceType = 0;
                _this.view.state.actionItem.resumeFileUploadToken.fileUrl = '';
                _this.view.state.actionItem.resumeFileUploadToken.deleteUrl = '';
                _this.view.state.actionItem.resumeFileUploadToken.title = '';
                _this.view.state.actionItem.resumeFileUploadToken.fileSize = 0;
                _this.view.state.actionItem.resumeFileUploadToken.fileIcon = '';
                _this.view.state.actionItem.resumeFileUploadToken.fileIconBackgroundColor = '';
                _this.view.state.showResumeUpload = true;
            }
        }
    };
}
exports.view = view;



//////////////////
// WEBPACK FOOTER
// C:/TeamCity/buildAgent/work/8b1685a0cde68c49/src/.tmp/ApplicationWorkflowResumeAction/View.js
// module id = 780
// module chunks = 0